import React, {useState} from 'react'
import style from "./headercomponent.module.css"
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import get from 'lodash/get'
import {IconButton, Menu, MenuItem} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { withRouter } from "react-router";

function HeaderComponent(props){

    const [state, setState]= React.useState({appList0:null});
    const title=get(props,"title")
    const headerList=get(props,"headerList")

    const getMenuItem = (item,anchor)=>{
        const type=get(item,"type")
        const text=get(item,"text")

         return <MenuItem
             key={type}
             style={{
                 minWidth: 180,
                 minHeight:50,
                 color: "rgba(0,0,0,0.8)",
                 fontSize: "12px",
                 lineHeight: "1.5em",
             }}
             value={type}
            onClick={handleMenuItemClick(item,anchor)}

         >
             <Typography className={style.headerDropdownAppTitle}>{text}</Typography>
         </MenuItem>;
    }
    const handleMenuItemClick = (item,anchor)=>()=> {
        const link=get(item,"link")
        const customFunc=get(item,"customFunc")
        console.log("navigateRoute anchor",anchor)
        handleClose(anchor)()
        if(customFunc){
            customFunc()
        }else{
            navigateRoute(link,anchor)
        }
    }

    const navigateRoute = (link)=>{

        props.history.push(link)
    }

    const getMenu = (anchor,menuList)=>{
        return (
            <Menu
                id="simple-menu"
                anchorEl={state[anchor]}
                keepMounted
                open={Boolean(state[anchor])}
                onClose={handleClose(anchor)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                MenuListProps={{
                    style: {
                        padding: 0,
                    },
                }}
                getContentAnchorEl={null}
            >

                {
                    menuList.map((item,index)=>{


                        return <div key={index}>
                            {getMenuItem(item,anchor)}
                        </div>
                    })
                }
            </Menu>
        )
    }
    const handleClose = (name) =>()=> {
        setState(prevState => ({ ...prevState, [name]: null }));

    };
    const handleIconClick =(name)=> (event)=>{
        console.log("navigateRoute handleIconClick anchor",name)
        setState(prevState => ({ ...prevState, [name]: event.currentTarget }));
    }

    console.log("navigateRoute appList0",state.appList0)
   return (
       <div className={style.headerContainer}>
           <Box padding={"15px 25px"}>
               <Grid container direction={"row"} justify={"space-between"} alignItems={"center"}>
                    <Grid item className={style.headerTitle}>
                        <span>{title}<sup className={style.supStyle}>BETA</sup></span>
                    </Grid>
                   <Grid item >
                       <Grid container direction={"row"} alignItems={"center"}>
                           {
                               headerList.map((item,itemIndex)=>{
                                   const icon=get(item,"icon");
                                   const name=get(item,"name");
                                   const menuList  =get(item,"menuList")
                                   return (
                                       <Grid item direction={"row"} key={itemIndex} className={style.headerIconList}>
                                           <Box paddingRight={"30px"}/>
                                           <IconButton onClick={handleIconClick(name + itemIndex)} className={style.headerIconButton}>
                                               {icon}
                                           </IconButton>

                                           {getMenu(name + itemIndex,menuList)}

                                       </Grid>
                                    )
                               })
                           }
                       </Grid>
                   </Grid>

               </Grid>
           </Box>
       </div>

   )
}

 export default withRouter(HeaderComponent);